import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { EconomicsHero } from "@/components/economics/EconomicsHero";
import { CostComparison } from "@/components/economics/CostComparison";
import { WhatWeEvaluate } from "@/components/economics/WhatWeEvaluate";
import { SiteSpecific } from "@/components/economics/SiteSpecific";

export default function Economics() {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="economics-page" className="bg-baseLight min-h-screen">
      <Navbar />
      <EconomicsHero />
      <CostComparison />
      <WhatWeEvaluate />
      <SiteSpecific />
      <Footer />
    </div>
  );
}
